export default __webpack_public_path__ + "static/bg-fd85d5f0ef68a525554bd7dc71fd1ee2.jpg";